var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.76842 16.4428C4.37556 16.4428 4.03925 16.3029 3.75949 16.0232C3.47972 15.7434 3.33984 15.4071 3.33984 15.0142V5.72853C3.33984 5.52615 3.4083 5.35651 3.5452 5.2196C3.68211 5.0827 3.85175 5.01425 4.05413 5.01425C4.25651 5.01425 4.42615 5.0827 4.56306 5.2196C4.69996 5.35651 4.76842 5.52615 4.76842 5.72853V15.0142H11.9113C12.1137 15.0142 12.2833 15.0827 12.4202 15.2196C12.5571 15.3565 12.6256 15.5262 12.6256 15.7285C12.6256 15.9309 12.5571 16.1006 12.4202 16.2375C12.2833 16.3744 12.1137 16.4428 11.9113 16.4428H4.76842ZM7.62556 13.5857C7.2327 13.5857 6.89639 13.4458 6.61663 13.166C6.33687 12.8863 6.19699 12.55 6.19699 12.1571V3.58568C6.19699 3.19282 6.33687 2.85651 6.61663 2.57675C6.89639 2.29699 7.2327 2.1571 7.62556 2.1571H14.0541C14.447 2.1571 14.7833 2.29699 15.0631 2.57675C15.3428 2.85651 15.4827 3.19282 15.4827 3.58568V12.1571C15.4827 12.55 15.3428 12.8863 15.0631 13.166C14.7833 13.4458 14.447 13.5857 14.0541 13.5857H7.62556ZM7.62556 12.1571H14.0541V3.58568H7.62556V12.1571Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1e559be5861dfe9f7e747ec0ed816e23.svg";
export { ForwardRef as ReactComponent };